import { lazy } from 'react';
import { wrapLazyNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';

const GuideToDownloadAppPageContent = lazy(
  () => import('./GuideToDownloadAppPageContent'),
);

export default wrapLazyNavigatorScreen(GuideToDownloadAppPageContent, {
  cardOverlayEnabled: true,
  animationEnabled: false,
  detachPreviousScreen: false,
  cardStyle: {
    backgroundColor: 'transparent',
  },
  headerShown: false,
});
